import { IUser, UserRoleEnum } from 'app/services/user';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserRole, useAuth } from 'utils/AuthProvider';

export default function useGoToUserProfile() {
  const navigate = useNavigate();

  const {
    isClient: iamClient,
    isAccountant: iamAccountant,
    isAdmin: iamAdmin,
    userId: myId,
    role,
    dashboard,
  } = useAuth();

  const navigateCb = (user: IUser) => {
    let link = '#';

    if (user.id === myId) {
      // go to my profile
      if ((iamClient || iamAccountant) && !iamAdmin) {
        link = `${
          iamClient
            ? '/dashboard/profile'
            : `/dashboard/accountant/${myId}/profileInfo`
        }`;
      }
      if (iamAdmin && iamAccountant) {
        link = `${dashboard}/accountant/${user.id}/profileInfo`;
      }
    } else {
      // some user objects does not have roles - BE should return roles object in all user responses
      // const isAccountant = user.profile_type === 'AccountantProfile';
      const { isClient, isAccountant } = getUserRole(user.roles);

      // go to other proflie
      if (isAccountant || user.profile_type === 'AccountantProfile') {
        link = `${dashboard}/accountant/${user.id}/profileInfo`;
      } else if (isClient) {
        link = `${dashboard}/clients/${user.id}/account`;
      }
    }

    navigate(link);
  };

  return navigateCb;
}
